// extracted by mini-css-extract-plugin
export default {"adBannerWrapper":"AdBanner_adBannerWrapper__w8-i2","adText":"AdBanner_adText__8Aov+"};